module.exports = __webpack_public_path__ + "img/finto-capital.72b73fcd.png";